import { dateToday, stringToDate } from 'helpers/date';

const getDiffYears = date => {
  const today = dateToday().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const dateNormalized = stringToDate(date);
  return today.diff(dateNormalized, 'years');
};

export const validateClientAge = (operator, birthDate, ageThreshold) => {
  const ages = getDiffYears(birthDate);

  if (operator === 'ge') {
    return ages >= parseInt(ageThreshold, 10);
  }

  if (operator === 'between') {
    if (ageThreshold.length !== 2)
      throw new Error(
        'El validador de fecha "between" debe tener 2 parámetros. min, max. Ejemplo: client_age_between:22,75'
      );

    const [min, max] = ageThreshold;
    return ages >= parseInt(min, 10) && ages < parseInt(max, 10);
  }

  return false;
};

export const validateDriverLicenseAge = (operator, dateLicense, minAges) => {
  const ageLicense = getDiffYears(dateLicense);

  if (operator === 'ge') {
    return ageLicense >= parseInt(minAges[0], 10);
  }

  return false;
};
